/* eslint-disable react/jsx-no-literals */
import { T } from '@/components/i18n/message.i18n.component';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion/accordion.component';
import { ProductBuildingBlock } from '@/gql/graphql';
import { pretailoringPageMessages } from '@/pages/products/pre-tailoring/pre-tailoring.messages';
import { BuildingBlockDetailsRow } from '../details-building-block.component';
interface Props {
  bb: ProductBuildingBlock;
}

export const DataBlocksTab = ({ bb }: Props) => {
  return (
    <Accordion type="single" collapsible className="w-full flex flex-col gap-y-4">
      {bb.dataBlocks?.map((db) => (
        <AccordionItem key={db.id} value={db.id || ''} className="border rounded border-other-stroke p-4">
          <AccordionTrigger
            className="w-full typo-primary-500"
            data-testid={`building-block-details-data-blocks-${db.id}-item-trigger`}
          >
            {db.name}
          </AccordionTrigger>
          <AccordionContent
            className="flex flex-col gap-y-2 data-[state=open]:mt-4"
            data-testid={`building-block-details-data-blocks-${db.id}-item-content`}
          >
            <BuildingBlockDetailsRow
              label={<T {...pretailoringPageMessages.singleBuildingBlockDataBlockDescription} />}
              value={db.description}
              context={`building-block-details-data-blocks-${db.id}-item-description`}
            />
            <BuildingBlockDetailsRow
              label={<T {...pretailoringPageMessages.singleBuildingBlockDataBlockDefinitionOfDone} />}
              value={db.definitionOfDone}
              context={`building-block-details-data-blocks-${db.id}-item-dod`}
            />
            <BuildingBlockDetailsRow
              label={<T {...pretailoringPageMessages.singleBuildingBlockDataBlockCompetencies} />}
              value={
                <>
                  {db.competencies.map((competency) => (
                    <div key={competency.id}>
                      <p className="typo-primary-400">
                        {competency.name} - {competency.description}
                      </p>
                    </div>
                  ))}
                </>
              }
              context={`building-block-details-data-blocks-${db.id}-item-competencies`}
            />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
